export default function () {
  return new URLSearchParams(document.location.search);
}
